const Highcharts = require('highcharts/highstock');
const perf_data = require('./performances/perf-charts-data');
const constants = require('../shared/constants');
const constantsShared = require('../shared/constants');

$(function () {
  const data = perf_data['from_start'] // default values -- should match the "checked" inputs // TODO find a better way
  $.each(data, function (i) {
    data[i].y = data[i].perf
  })
  const categories = $.map(data, function (d) {
    return d.composition
  })

  const options = {
    colors: constants.COLORS.PROFILES,
    chart: {
      type: 'column',
      style: {
        fontSize: '1em'
      }
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: categories,
      tickLength: 0,
      lineColor: '#5D6B7C',
      labels: {
        useHTML: true,
        formatter: function () {
          const cat = this.axis.categories,
            v = '<span class="mobile-hide" style="display: block;border-radius: 10px;color: #fff;font-size: 18px;line-height: 23px;width:40px;height: 40px;line-height: 40px;margin-top:8px; background-color: ' + constants.COLORS.PROFILES[cat.indexOf(this.value)] + '">P' + (cat.indexOf(this.value) + 1) + '</span>',
            html = "<span class='mobile-fontsize' style=\"display: block; margin-left: auto; margin-right: auto; text-align: center; font-size: 12px; color: #858B9D; font-weight: 600; font-family: "+ constantsShared.FONT_CHARTS.fontFamily +"; text-align: center; line-height: 16px\">" + this.value + v + '</span>'
          return html
        },
        autoRotation: false
      }
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        enabled: false
      },
      gridLineColor: '#F1F2F4',
      gridLineDashStyle: 'dash',
      gridLineWidth: 1.5,
      minPadding: 0.1
    },
    tooltip: {
      headerFormat: '',
      backgroundColor: 'rgba(239,243,247, 0.85)',
      borderWidth: 0,
      borderRadius: 7,
      shadow: false,
      style: {
        fontFamily: constantsShared.FONT_CHARTS.fontFamily,
        fontSize: '16px',
        fontWeight: 'normal',
        zIndex: 10,
        color: '#5C6B7E'
      },
      useHTML: true,
      formatter: function () {
        const id = this.point.x
        const name = this.point.options.name
        const perf = this.y
        const vol = this.point.options.vol
        const color = this.point.color
        let text = "<span style='color: " + color + "; font-weight: 600'>P" + (id + 1) + " : " + name + "</span><br />Perf. <span style='color: " + color + "'>" + perf + "%</span>"

        if (vol != null) {
          text += "<br />Vol. " + vol + "%"
        }

        return text
      },
      positioner: function (label_width, label_height, point) {
        const x = point.plotX - label_width / 2 + this.chart.plotLeft
        const y = point.plotY - label_height - 30
        return {
          x: x,
          y: y
        }
      }
    },
    series: [{
      colorByPoint: true,
      data: $.extend(true, [], data)
    }],
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        dataLabels: {
          enabled: true,
          crop: false,
          overflow: 'none',
          formatter: function() {
            return `<span style="color: ${this.point.color}; font-family: ${constantsShared.FONT_CHARTS.fontFamily}; font-size: 18px; font-weight: 600;">${this.y}%</span>`;
          },
          style: {
            fontSize: '1em',
            fontWeight: 600
          }
        },
        groupPadding: 0.04,
        borderWidth: 0,
        pointPadding: 0.15
      }
    }
  }

  const self = {
    chart: '',
    $el: $('#js-performance-chart'),
    options: options
  }

  self.chart = self.$el.highcharts(self.options).highcharts()
  $('.text-optionel').text('Données communiquées par Suravenir')
  $('.text-optionel.bis').text('Documentation publicitaire dépourvue de valeur contractuelle')

  // periodicity selector
  $('.info-old-regime-msg').hide()
  $('ul.tabs li').click(function () {
    const mode = $(this).attr('data-tab');
    // update selector
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    // update bloc content
    if (mode === "calendar") {
      $('.info-old-regime-msg').show()
      $('.calendar').show()
      $('.cumul').hide()
      $('.annual').hide()
      $(".custom-select-trigger").text('2026')
      updateDataPoolsChart(2026);
      updateDataPoolsMsg(2026)
    } else if (mode === "cumul") {
      $('.info-old-regime-msg').hide()
      $('.cumul').show()
      $('.calendar').hide()
      $('.annual').hide()
      $(".custom-select-trigger").text('depuis le lancement')
      updateDataPoolsChart("from_start");
      updateDataPoolsMsg("from_start")
    } else {
      $('.info-old-regime-msg').hide()
      $('.cumul').hide()
      $('.calendar').hide()
      $('.annual').show()
      updateDataPoolsChart(mode);
      updateDataPoolsMsg("from_start")
      $('.text-optionel').text('Données communiquées par Suravenir')
      $('.text-optionel.bis').text('Documentation publicitaire dépourvue de valeur contractuelle')
      $('.text-for-2016').hide()
    }
  })

  // custom select
  $(".custom-select").each(function () {
    const classes = $(this).attr("class");
    let template = '<div class="' + classes + '">';
    template += '<span class="custom-select-trigger">' + $(this).attr("placeholder") + '</span>';
    template += '<div class="custom-options">';
    $(this).find("option").each(function () {
      template += '<span class="custom-option ' + $(this).attr("class") + '" data-value="' + $(this).attr("value") + '">' + $(this).html() + '</span>';
    });
    template += '</div></div>';

    $(this).wrap('<div class="custom-select-wrapper"></div>');
    $(this).hide();
    $(this).after(template);
  });
  $(".custom-option:first-of-type").hover(function () {
    $(this).parents(".custom-options").addClass("option-hover");
  }, function () {
    $(this).parents(".custom-options").removeClass("option-hover");
  });
  $(".custom-select-trigger").on("click", function () {
    $('html').one('click', function () {
      $(".custom-select").removeClass("opened");
    });
    $(this).parents(".custom-select").toggleClass("opened");
    event.stopPropagation();
  });
  $(".custom-option").on("click", function () {
    const selector = $(this).data("value")

    updateDataPoolsMsg(selector)
    // update selection
    $(this).parents(".custom-select-wrapper").find("select").val($(this).data("value"));
    $(this).parents(".custom-options").find(".custom-option").removeClass("selection");
    $(this).addClass("selection");
    $(this).parents(".custom-select").removeClass("opened");
    $(this).parents(".custom-select").find(".custom-select-trigger").text($(this).text());
    // update graph
    updateDataPoolsChart(selector)
    if ([2018, 2019, 2020, 2021, 2022, 2023, 2024, "one_year", "three_years"].indexOf(selector) >= 0) {
      $('.info-old-regime-msg').show()
    } else {
      $('.info-old-regime-msg').hide()
    }

    if ([2016, 2017, 2018].includes(selector)) {
      $('.text-optionel').text('Données calculées par WeSave')
      $('.text-optionel.bis').text('Documentation publicitaire dépourvue de valeur contractuelle')
      if (selector === 2016) {
        $('.text-for-2016').show()
      } else {
        $('.text-for-2016').hide()
      }
    } else {
      $('.text-optionel').text('Données communiquées par Suravenir')
      $('.text-optionel.bis').text('Documentation publicitaire dépourvue de valeur contractuelle')
      $('.text-for-2016').hide()
    }
  });

  function updateDataPoolsMsg(selector) {
    let datesPoolMsg = "Performances calculées sur la période du "
    // Last full date 31/12/2025
    const lastPerformanceDayAndMonth = '30/06'
    const lastPerformanceYear = 2026

    const lastPerformanceDate = `${lastPerformanceDayAndMonth}/${lastPerformanceYear}`

    switch (selector) {
      case 'from_start':
        datesPoolMsg += `19/02/2016 à ${lastPerformanceDate}`;
        break;
      case 'three_years':
        datesPoolMsg += `${lastPerformanceDayAndMonth}/${lastPerformanceYear - 3} à ${lastPerformanceDate}`;
        break;
      case 'five_years':
        datesPoolMsg += `${lastPerformanceDayAndMonth}/${lastPerformanceYear - 5} à ${lastPerformanceDate}`;
        break;
      case 'one_year':
        datesPoolMsg += `${lastPerformanceDayAndMonth}/${lastPerformanceYear - 1} à ${lastPerformanceDate}`;
        break;
      case 2016:
        datesPoolMsg = '';
        $('#dates-pool-msg').html('Performances calculées sur la période du 19/02/2016 <sup>(3)</sup> à 31/12/2016');
        break;
      case lastPerformanceYear:
        datesPoolMsg += `31/12/${lastPerformanceYear - 1} à ${lastPerformanceDate}`;
        break;
      default:
        datesPoolMsg += "31/12/" + (selector - 1) + " à 31/12/" + selector;
        break;
    }
    if (datesPoolMsg.length > 0) {
      $('#dates-pool-msg').text(datesPoolMsg)
    }

  }

  function updateDataPoolsChart(selector) {
    let series = perf_data[selector]
    series = perf_data[selector]
    $.each(series, function (i) {
      series[i].y = series[i].perf
    })
    self.chart.series[0].setData(series)
  }

  // INFO BLOCKS
  $('.open-info').on('click', function () {
    const perf = $(this).parents('[data-block]').attr('data-block'),
      $target = $('.chart-info[data-info=' + perf + ']')

    $target.show().prev().hide()
  });

  $('.close-info').on('click', function () {
    $(this).parent().hide().prev().show()
  });
})
